<template>
  <div style="width: 100%">
    <div class="text-center" style="width: 100%">
      <button class="card-tarja-btn" @click="handleClick" :disabled="isDisabled">
        <v-icon>mdi-fit-to-screen</v-icon>
        <span>Tela cheia</span>
      </button>
    </div>

    <ModalConfirmAction
      :visible="showDialog"
      title="Exibir enquete na tarja em tela cheia"
      message="Tem certeza que deseja exibir a enquete na tarja?"
      confirm-text="Exibir"
      confirm-color="primary"
      :loading="loading"
      @confirm="confirmExibir"
      @cancel="showDialog = false"
    />
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import ModalConfirmAction from "@/components/Modal/ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    codProducao: Number,
    id_enquete: Number,
    isDisabled: Boolean,
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      exibirModalConfirmacao: null,
    };
  },
  async created() {
    await this.getConfigTarja({ cod_producao: this.codProducao });
    this.exibirModalConfirmacao = this.configTarja.flg_botao_confirmar_exibicao;
  },
  computed: {
    ...mapGetters({
      configTarja: "tarja_enquete/getConfigTarja",
    }),
  },
  methods: {
    ...mapActions({
      assignTarjaParams: "tarja_enquete/assignTarjaParams",
      getConfigTarja: "tarja_enquete/getConfigTarjaEnquete",
    }),
    handleClick() {
      if (this.exibirModalConfirmacao) {
        this.showDialog = true;
      } else {
        this.setEnqueteTarja({
          codProducao: this.codProducao,
          idEnquete: this.id_enquete,
          isFullScreen: true,
        });
      }
    },
    confirmExibir() {
      this.setEnqueteTarja({
        codProducao: this.codProducao,
        idEnquete: this.id_enquete,
      });
    },
    async setEnqueteTarja(value) {
      await apiClient.patch(
        `atualizarFlgIsFullScreenTarjaEnquete/${this.configTarja.id}/${this.codProducao}`,
        {
          flg_is_fullscreen: true,
        }
      );
      this.loading = true;
      this.assignTarjaParams(value);
      localStorage.setItem("tarjaParams", JSON.stringify(value));
      this.$emit("change");
      setTimeout(() => {
        this.loading = false;
        this.showDialog = false;
      }, 250);
    },
  },
  watch: {
    "$store.state.tarja_enquete.configTarjaEnquete": function (newValue) {
      this.exibirModalConfirmacao = newValue.flg_botao_confirmar_exibicao;
    },
  },
};
</script>

